// extracted by mini-css-extract-plugin
export default {"alert_card_close":"AlertClose_alert_card_close__BiTf5","bigger_title":"AlertClose_bigger_title__+q2g2"};